<template>
  <div>
    <div class="w120 mc mt20 bg-w pb20 pl20 pr20">
      <div class="po-r pt20 pb20 w100 tx-c" v-if="appData">
        <span class="font-18">{{ appData.name }}</span>
      </div>
      <component :is="isComp()" :app-data="appData" :collecting="collecting" :url="compName" @click-collect="clickCollect" />
    </div>

    <!-- <div class="w120 mc mt20 pt20 pb20 pl20 pr20 bg-w" style="min-height: 100px;" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.4)">
      <section v-if="appData">
        <p class="w100 pb20 tx-c font-18">业务说明</p>
        <div class="po-r w100 bor-t bor-l font-14 flex-box server-info" v-for="(item, index) in msgData" :key="index">
          <div style="flex: 1;" v-for="(val, key) in item" :key="key">
            <div class="h100 flex-box">
              <div class="h100 pt20 pb20 pl20 pr20 bor-r tx-c flex-1">{{ val.label }}</div>
              <div class="h100 pt20 pb20 pl20 pr20 bor-r flex-5">
                <span v-if="val.label != '评分情况'">{{ val.content }}</span>
                <el-rate v-else v-model="val.content" disabled></el-rate>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div> -->
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import StuScore from "@/components/SearchInfo/StuScore";
import StudentTuition from "@/components/SearchInfo/StudentTuition";
import BookBorrow from "@/components/SearchInfo/BookBorrow";
import HygieneInspect from "@/components/SearchInfo/HygieneInspect";
import StudentArchives from "@/components/SearchInfo/StudentArchives";
import StudentPunishment from "@/components/SearchInfo/StudentPunishment";
import StuCourse from "@/components/SearchInfo/StuCourse";
import MilitaryTrain from "@/components/SearchInfo/MilitaryTrain";

export default {
  name: "server_info",
  components: {
    StuScore,
    StudentTuition,
    BookBorrow,
    HygieneInspect,
    StudentArchives,
    StudentPunishment,
    StuCourse,
    MilitaryTrain
  },
  data() {
    return {

      loading: false,
      error: 0,
      errorMsg: "",
      appData: null,
      collecting: false,

      compName: ""
    };
  },
  computed: {
    ...mapState(["userData"]),
    msgData() {
      let arr = [];
      if (this.appData && this.appData.main.length > 0) {
        let twoData = [];
        for (const item of this.appData.main) {
          twoData = [...twoData, item];
          twoData.length == 2
            ? ((arr = [...arr, twoData]), (twoData = []))
            : null;
        }
      }
      return arr;
    }
  },
  created() {
    if (
      !this.$route.query.id ||
      this.$route.query.id == "" ||
      !this.$route.query.interfaceUrl ||
      this.$route.query.interfaceUrl == ""
    ) {
      this.$notify({
        title: "错误",
        message: "查询服务参数出错，未有该服务可用",
        type: "error",
        offset: 60
      });
      this.$router.push({ name: "home" });
    } else {
      this.compName = this.$route.query.interfaceUrl;
      this.fetchAppData();
    }
  },
  mounted() {},
  methods: {
    fetchAppData() {
      this.loading = true;

      this.$http
        .post(
          `serve/findById`,
          this.$qs.stringify({
            id: this.$route.query.id
          })
        )
        .then(({ data }) => {
          if (data.RetStatus == 0) {
            this.appData = data.RetData;

            if (this.appData % 2 == 1) {
              this.appData.push({
                label: "",
                content: ""
              });
            }
          } else {
            this.$notify({
              title: "错误",
              message: data.RetMsg,
              type: "error",
              offset: 60
            });
          }

          this.loading = false;
        })
        .catch(() => {
          this.error = 404;
          this.$notify({
            title: "错误",
            message: "页面请求错误，请检查网络",
            type: "error",
            offset: 60
          });

          this.loading = false;
        });
    },
    clickCollect(isTrue) {
      this.collecting = true;
      const URL = !isTrue ? `serveCollection/newCo` : `serveCollection/delCo`;
      this.$http
        .post(
          URL,
          this.$qs.stringify({
            userId: this.userData.userId,
            serveId: this.$route.query.id
          })
        )
        .then(({ data }) => {
          if (data.resStatus == 0 && data.resCode == 0) {
            this.appData.isCollect = !isTrue;
            this.$notify({
              title: "成功",
              message: data.resMsg,
              type: "success",
              offset: 60
            });
          } else {
            this.$notify({
              title: "错误",
              message: data.resMsg,
              type: "error",
              offset: 60
            });
          }
          this.collecting = false;
        })
        .catch(() => {
          this.$notify({
            title: "错误",
            message: "操作失败，请检查网络",
            type: "error",
            offset: 60
          });
          this.collecting = false;
        });
    },
    isComp() {
      switch (this.$route.query.interfaceUrl) {
        case "stuScore":
          return "StuScore";
          break;
        case "studentTuition":
          return "StudentTuition";
          break;
        case "bookBorrow":
          return "BookBorrow";
          break;
        case "hygieneInspect":
          return "HygieneInspect";
          break;
        case "studentArchives":
          return "StudentArchives";
          break;
        case "studentPunishment":
          return "StudentPunishment";
          break;
        case "stuCourse":
          return "StuCourse";
          break;
        case "militaryTrain":
          return "MilitaryTrain";
          break;
        default:
          this.$notify({
            title: "错误",
            message: "查询服务参数出错，未有该可用服务",
            type: "error",
            offset: 60
          });
          this.$router.push({ name: "home" });
          break;
      }
    }
  }
};
</script>

<style scoped>
.server-info:last-child:after {
  content: "";
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background: #ccc;
}

.btn-collect {
  right: 0;
  top: 50%;
  -webkit-transform: translate(0, -50%);
  -moz-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  -o-transform: translate(0, -50%);
  transform: translate(0, -50%);
}
</style>
